import React from "react";
import {
  Box,
  Container,
  Heading,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
} from "@chakra-ui/react";
import image from "../assets/home_background_image.jpg";
import Login from "../components/Login";
import Signup from "../components/Signup";
export const backendurl = 'https://wechat-backend-fob0.onrender.com/'

const Home = () => {
  return (
    <Box
      minH="100vh"
      position="relative"
      overflow="hidden"
    >
      {/* Background Image */}
      <Box
        position="absolute"
        top={0}
        left={0}
        zIndex={-1}
        w="100%"
        h="100%"
        bgImage={`url(${image})`}
        bgSize="cover"
        bgPosition="center"
        bgRepeat="no-repeat"
        opacity={0.2} // Adjust the opacity value as needed (0.2 for 20% opacity)
      />

      {/* Content */}
      <Container maxW="xl" centerContent boxShadow="md" zIndex={1} position="relative">
        <Box
          bgGradient="linear-gradient(333deg, rgba(131,58,180,1) 0%, rgba(175,48,126,1) 22%, rgba(180,47,120,1) 42%, rgba(253,29,29,1) 57%, rgba(253,91,46,1) 79%);"
          bgClip="text"
          textAlign="center"
          p="12"
        >
          <Heading
            as="h2"
            size="3xl"
            fontWeight="bold"
            fontFamily="sans-serif"
            _selection={{ bg: "transparent" }}
          >
            WECHAT
          </Heading>
        </Box>
        <Box w="100%" p="30px" borderRadius="lg" borderWidth="2px" borderColor="blue">
          <Tabs variant="soft-rounded">
            <TabList mb="1em">
              <Tab w="50%">Login</Tab>
              <Tab w="50%">Sign Up</Tab>
            </TabList>
            <TabPanels>
              <TabPanel>
                <Login />
              </TabPanel>
              <TabPanel>
                <Signup />
              </TabPanel>
            </TabPanels>
          </Tabs>
        </Box>
      </Container>
    </Box>
  );
};

export default Home;
